import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../molecules/RoundedModal'
import SydButton from '../../../../commonDesign/Button'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'

const DeleteDagDialog = React.forwardRef(function DeleteDagDialog ({ onConfirm }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, dag: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, dag: null })
  }, [])

  const handleConfirm = useCallback(async () => {
    try {
      setDialogState((prev) => ({ ...prev, processing: true }))
      await onConfirm(dialogState.dag)
    } finally {
      close()
    }
  }, [dialogState.dag, onConfirm, close])

  useImperativeHandle(ref, () => ({
    open: (dag) => {
      setDialogState({ open: true, processing: false, dag })
    }
  }), [])

  return (
    <RoundedModal
      title='Delete Workflow'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <>
            <p>
              Are you sure you want to delete workflow{' '}
              <strong>{dialogState.dag?.name}</strong>? This will permanently remove
              the DAG definition, all execution history, and logs. This action cannot be undone.
            </p>
            <SydModalActions>
              <SydButton disabled={dialogState.processing} variant='ghost' size='md' onClick={close}>
                Cancel
              </SydButton>
              <SydButton
                processing={dialogState.processing}
                variant='primary'
                priority='warning'
                icon='delete'
                size='md'
                onClick={handleConfirm}
              >
                Delete
              </SydButton>
            </SydModalActions>
          </>
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteDagDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired
}

export default DeleteDagDialog
